import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { TrashIconForPopup } from "../../assets/Icon/headerCicon";
import {
  CloseButton,
  CloseButtonWrapper,
  ModalWrapper,
} from "../../components/style/modalStyle";
import { ModalTop, ModalBottom, CrossIcon } from "../../assets/Icon/ModalIcon";
import NoSubscriptionsImg from "../../assets/Images/subs.svg";
import { useDispatch } from "react-redux";
import {
  deleteSubscriptions,
  getSubscriptionsData,
} from "../../stores/clients";
import { setToast } from "../../stores/toast/toastslice";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import SubscriptionCard from "./components/SubscriptionCard";

const Subscriptions = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [data, setData] = useState<any>();
  const [modalOpen, setModalOpen] = useState(false);
  const [cancelledData, setCanceledData] = useState<any>();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const fetchData = async () => {
    await dispatch<any>(getSubscriptionsData()).then((res: any) => {
      setData(res?.payload);
    });
  };

  useEffect(() => {
    fetchData();

    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2500);

    return () => clearTimeout(timeout);
  }, []);

  const deleteSubscription = async () => {
    setLoading(true);
    await dispatch<any>(
      deleteSubscriptions({
        subscription_id: cancelledData?.subscription_id,
        subscription_type: cancelledData?.title?.toLowerCase(),
      }),
    )
      .then(() => {
        dispatch<any>(
          setToast({
            message: "Subscription Cancelled!",
            type: "success",
            title: "Success",
          }),
        );
        setModalOpen(false);
        fetchData();
      })
      .finally(() => setLoading(false));
  };

  const handleCancel = () => {
    setModalOpen(false);
  };

  if (loading) {
    return <ListLoadingNew />;
  }

  if (
    !data?.bookkeeping?.amount &&
    !data?.invoicing?.amount &&
    !data?.bookkeeping?.is_admin_trial &&
    !data?.invoicing?.is_admin_trial
  ) {
    return (
      <Box
        sx={{
          background: "white",
          paddingY: isMobile ? "40px" : "126px",
          paddingX: isMobile ? "10px" : 0,
          textAlign: "center",
          display: "grid",
          justifyItems: "center",
          boxShadow: `
          0px 1px 2px 0px #00000005,
          0px 3px 3px 0px #00000005,
          0px 7px 4px 0px #00000003,
          0px 12px 5px 0px #00000000,
          0px 18px 5px 0px #00000000
        `,
          borderRadius: "10px",
          width: isMobile ? "100%" : undefined,
          maxWidth: isMobile ? "100%" : "unset",
        }}
      >
        {/* {isMessage ? <NOMessageIcon /> : <NoDataFoundImage />} */}
        {/* {buttonTitle ? (
          <img
            src={Image}
            alt="no-data-img"
            style={{ width: isMobile ? "140px" : "228px", maxWidth: "100%" }}
          />
        ) : isMessage ? (
          <NOMessageIcon />
        ) : (
          <NoDataFoundImage />
        )} */}
        <img
          src={NoSubscriptionsImg}
          className="w-[240px] h-[256px]"
          alt="img"
        />
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: isMobile ? "18px" : "28px",
            lineHeight: isMobile ? "28px" : "46px",
            color: "#05000B",
            paddingTop: 3,
            paddingBottom: 1,
          }}
        >
          No Subscriptions Yet!
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: isMobile ? "12px" : "16px",
            lineHeight: isMobile ? "18px" : "28px",
            color: "#6C6F71",
            paddingBottom: 8,
            width: isMobile ? "100%" : "500px",
            maxWidth: "100%",
            textAlign: "center",
          }}
        >
          You haven’t purchased any plan. Choose a subscription to unlock
          invoicing and bookkeeping features.
        </Typography>
      </Box>
    );
  }

  return (
    <div>
      <div
        style={{
          fontSize: "24px",
          fontWeight: 500,
        }}
      >
        Your Current Plans
      </div>

      {/** INVOICING */}
      <SubscriptionCard
        subscription={data?.invoicing}
        setModalOpen={setModalOpen}
        setCanceledData={setCanceledData}
      />

      {/** BOOKKEEEPING */}
      <SubscriptionCard
        subscription={data?.bookkeeping}
        setModalOpen={setModalOpen}
        setCanceledData={setCanceledData}
      />

      <Modal open={modalOpen} onClose={handleCancel}>
        <ModalWrapper
          sx={{
            width: isMobile ? "350px" : "500px",
            p: 0,
            height: "440px",
            backgroundImage: "none",
            position: "relative",
            borderRadius: "20px",
            overflow: "hidden",
            outline: "none",
          }}
        >
          {/* Top right decoration */}
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 1,
            }}
          >
            <ModalTop />
          </div>
          {/* Bottom left decoration */}
          <div
            style={{
              position: "absolute",
              bottom: -6,
              left: 0,
              zIndex: 1,
            }}
          >
            <ModalBottom />
          </div>
          {/* Ensure close button is above decorations */}
          <CloseButtonWrapper
            sx={{ zIndex: 10, position: "relative", marginTop: 1 }}
          >
            <CloseButton onClick={handleCancel}>
              <CrossIcon />
            </CloseButton>
          </CloseButtonWrapper>
          <Box sx={{ p: 4, pt: 0 }}>
            {/* Trash icon with red bg */}
            <Box
              sx={{ display: "flex", justifyContent: "center", mt: 1, mb: 2 }}
            >
              <Box
                sx={{
                  background: "#F20F0014",
                  borderRadius: "50%",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TrashIconForPopup />
              </Box>
            </Box>
            <div
              style={{
                textAlign: "center",
                fontSize: isMobile ? "20px" : "24px",
                color: "#01060B",
                fontWeight: 700,
                marginTop: 0,
                marginBottom: 10,
              }}
            >
              Cancel Subscription at End <br /> of Billing Cycle
            </div>
            <div
              style={{
                width: isMobile ? "100%" : "370px",
                textAlign: "center",
                lineHeight: "24px",
                margin: "0 auto",
                fontSize: isMobile ? "12px" : "16px",
                color: "#6C6F71",
                fontWeight: 500,
                fontFamily: "Plus Jakarta Sans",
              }}
            >
              Are you sure you want to cancel your subscription? It will remain
              active until the end of the current billing cycle.
            </div>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 3,
                justifyContent: "center",
              }}
            >
              <Button
                sx={{
                  border: "2px solid #2977CC",
                  borderRadius: "8px",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#2977CC",
                  cursor: "pointer",
                }}
                onClick={handleCancel}
              >
                Close
              </Button>
              <Button
                sx={{
                  background: false
                    ? "#ccc"
                    : "linear-gradient(to right, #2977CC, #1D538F)",
                  color: "white",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
                onClick={deleteSubscription}
              >
                {"Yes"}
              </Button>
            </Box>
          </Box>
        </ModalWrapper>
      </Modal>
    </div>
  );
};

export default Subscriptions;
